import { map, fromPairs, pipe } from "ramda";

export const streamDataToMap = pipe(
  map(datum => [datum.time, parseFloat(datum.value)]),
  fromPairs
);
